import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpStatusCode,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'angular-web-storage';
import { Observable, Subscriber } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SessionService } from '../session/session.service';
import { LoadingService } from 'src/app/components/loading/loading-service.service';
import { Router } from '@angular/router';

const ENVIRONMENTS: { [name: string]: string } | undefined =
  environment.api.environments ?? undefined;

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  host: any;
  apiName: any;

  constructor(
    private storage: LocalStorageService,
    public http: HttpClient,
    private loader: LoadingService,
    private route: Router
  ) {
    this.setHost();
  }

  setHost() {
    if (!environment.production) {
      this.apiName = this.storage.get('environmentName');
      const definitions = Object.entries(environment.api.environments);

      if (this.apiName) {
        for (const [name, url] of definitions) {
          if (this.apiName[0] == name) {
            this.host = url;
          }
        }
      }

      //this.host = environment.api.environments.SENSEDIA_DSV;
    } else {
      this.host = environment.api.baseUrl;
    }
  }

  query(endpoint: string, data: object, method: string) {
    const httpHeaders: HttpHeaders = new HttpHeaders({
      'x-app-version': environment.version,
      'x-os-name': 'Desktop',
    });

    let result;

    switch (method) {
      case 'post':
        result = this.http.post(this.host + '/' + endpoint, data, {
          headers: httpHeaders,
        });

        break;

      case 'get':
        result = this.http.get(this.host + '/' + endpoint, data);

        break;

      case 'put':
        result = this.http.put(this.host + '/' + endpoint, data, {
          headers: httpHeaders,
        });

        break;
    }

    return result;
  }

  async setEnvironment(name: string) {
    if (ENVIRONMENTS?.[name]) {
      await this.storage.set('environmentName', name);
      this.setHost();
    }
  }

  getEnvironment() {
    return this.apiName;
  }

  logout() {
    const body = {
      requisicao: {
        Token: this.storage.get('Token'),
      },
    };

    this.loader.startLoading();
    this.query('/auth/logout', body, 'post')?.subscribe((data) => {
      const apiName = this.getEnvironment();
      this.storage.clear();
      if (apiName) {
        this.setEnvironment(apiName);
      }

      this.route.navigate(['/login']).then(() => {
        window.location.reload();
        this.loader.stopLoading();
      });
    });
  }
}
